var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"folder-node-selection-count folder-node-selection-count__root"},[(_vm.count > 0)?_c('pui-flex',{staticClass:"folder-node-selection-count__count",attrs:{"justifyContent":"center","alignItems":"center"}},[_vm._v("\n    "+_vm._s(_vm.count)+"\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }